import script from "./Building.vue?vue&type=script&setup=true&lang=js"
export * from "./Building.vue?vue&type=script&setup=true&lang=js"

import "./Building.vue?vue&type=style&index=0&id=6865ce30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6865ce30"]])

export default __exports__